<dojo-table-of-contents [items]="tocItems()" (itemClick)="onItemClick($event)" />
